import { render } from "./InputCheckboxes.vue?vue&type=template&id=850e08ca"
import script from "./InputCheckboxes.vue?vue&type=script&lang=ts"
export * from "./InputCheckboxes.vue?vue&type=script&lang=ts"
script.render = render

export default script